import React from 'react';
import { Navigate } from 'react-router-dom';

import Home from './pages/Home';
import Badge from './pages/Badge';
import Storie from './pages/Storie';
import Group from './pages/Group';
import Socialaccount from './pages/Socialaccount';
import Password from './pages/Password';
import AccountInfo from './pages/AccountInfo';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Register from './pages/Register';
import Notfound from './pages/Notfound';
import Notification from './pages/Notification';
import Email from './pages/Email';
import Message from './pages/Message';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Shopone from './pages/Shopone';
import Shoptwo from './pages/Shoptwo';
import Payment from './pages/Payment';
import Contactinfo from './pages/Contactinfo';
import Video from './pages/Video';
import GroupPage from './pages/Grouppage';
import Userpage from './pages/Userpage';
import AthleteMatchesPage from './pages/atleta/matches';
import Authorpage from './pages/Authorpage';
import Jobpage from './pages/Jobpage';
import Hotelpage from './pages/Hotelpage';
import Hotelsingle from './pages/Hotelsingle';
import Helpbox from './pages/Helpbox';
import Eamilopen from './pages/Eamilopen';
import Singleproduct from './pages/Singleproduct';
import Analytic from './pages/Analytic';
import CuponsPage from './pages/admin/cupons';
import AdminUsuarios from './pages/admin/AdminUsuarios';

// public pages
import Landingpage from './pages/public/Landingpage';
import InstitucionalHome from './pages/public/institucional/InstitucionalHome';
import InstitucionalTorneios from './pages/public/institucional/InstitucionalTorneios';
import InstitucionalGestao from './pages/public/institucional/InstitucionalGestao';
import InstitucionalLocacao from './pages/public/institucional/InstitucionalLocacao';
import InstitucionalParceiros from './pages/public/institucional/InstitucionalParceiros';
import InstitucionalClube from './pages/public/institucional/InstitucionalClube';
import TermosDeUso from './pages/public/TermosDeUso';
import Comingsoon from './pages/public/Comingsoon';
import Forgot from './pages/public/Forgot';
import ForgotRequest from './pages/public/ForgotRequest';
import Eventpage from './pages/public/Eventpage';
import LeaguesPage from './pages/public/LeaguesPage';
import LeagueProfilePage from './pages/public/LeagueProfilePage';
import PostPage from './pages/public/PostPage';
import Live from './pages/public/Live';
import About from './pages/public/About';
import Demo from './pages/public/Demo';
import SingleMatchPage from './pages/atleta/singlematch';
import Tournamentsingle from './pages/Tournamentsingle';
// Quadras
import CidadesQuadras from './pages/quadras/CidadesQuadras';
import QuadrasDisponiveis from './pages/quadras/QuadrasDisponiveis';
import QuadraDetalhe from './pages/quadras/QuadraDetalhe';
import MeusAgendamentos from './pages/quadras/MeusAgendamentos';
import PagamentoAgendamento from './pages/quadras/PagamentoAgendamento';
import PagamentoPedido from './pages/quadras/PagamentoPedido';
import PedidoDetalhe from './pages/quadras/PedidoDetalhe';
import LocalDetalhe from './pages/quadras/LocalDetalhe';
import AdminQuadrasDashboard from './pages/quadras/admin/AdminQuadrasDashboard';
import AdminQuadraForm from './pages/quadras/admin/AdminQuadraForm';
import AdminConfigurarQuadra from './pages/quadras/admin/AdminConfigurarQuadra';
import AdminTaxaConveniencia from './pages/quadras/admin/AdminTaxaConveniencia';
import AdminAgenda from './pages/quadras/admin/AdminAgenda';
import AdminRelatorio from './pages/quadras/admin/AdminRelatorio';
import AdminAgendaLocal from './pages/quadras/admin/AdminAgendaLocal';

// Torneios, Ligas, Pagamentos
import TournamentCategoryPage from './pages/public/TournamentCategoryPage';
import TournamentInscriptionCheckout from './pages/TournamentInscriptionCheckout';
import TournamentInscriptions from './pages/atleta/TournamentInscriptions';
import NewInscriptionPayment from './pages/atleta/NewInscriptionPayment';
import ViewInscriptionPayment from './pages/atleta/ViewInscriptionPayment';
import Payments from './pages/atleta/Payments';
import InscricaoDetailPage from './pages/atleta/InscricaoDetailPage';
import FinanceiroHub from './pages/atleta/financeiro/FinanceiroHub';
import AdminPayments from './pages/admin/Payments';
import CreditCard from './components/CreditCard';
import Tournaments from './pages/admin/Tournaments';
import Ligas from './pages/admin/Ligas';
import AdminEditLeague from './pages/admin/AdminEditLeague';
import TournamentFeed from './pages/admin/TournamentFeed';
import EditTournament from './pages/admin/EditTournament';
import AdminTournamentSponserPage from './pages/admin/sponser';
import AdminTournamentOrganizerPage from './pages/admin/organizer';
import AdminTournamentDiscountPage from './pages/admin/discount';
import EditCategoryTournament from './pages/admin/EditCategoryTournament';
import TournamentCategoryMatches from './pages/admin/TournamentCategoryMatches';
import AdminAthletesPage from './pages/admin/athletes';
import EditAthlete from './pages/admin/EditAthlete';
import PaymentMethods from './pages/admin/PaymentMethods';
import EmailsNotificacoes from './pages/admin/EmailsNotificacoes';
import FinanceiroAdminPage from './pages/admin/financeiro/FinanceiroAdminPage';
import AthletePaymentsPage from './pages/admin/athlete/payments/[id]';
import SystemUnavailablePage from './pages/system-unavailable';
import BreadcrumbDemoPage from './pages/dev/breadcrumb-demo';
import LeagueDashboard from './pages/liga/LeagueDashboard';
import EditLeague from './pages/liga/EditLeague';
import LeagueTournaments from './pages/liga/LeagueTournaments';
import LeagueTournamentManagement from './pages/liga/LeagueTournamentManagement';
import LeagueEditCategoryTournament from './pages/liga/LeagueEditCategoryTournament';
import LeagueCategoriaLigaCatalog from './pages/liga/categoriaLiga/LeagueCategoriaLigaCatalog';
import LeagueCategoriaLigaForm from './pages/liga/categoriaLiga/LeagueCategoriaLigaForm';
import LeagueCategoryManagement from './pages/liga/LeagueCategoryManagement';
import CategoryPrintPage from './pages/liga/categoryManagement/CategoryPrintPage';
import EditInscricaoPage from './pages/liga/inscricao/EditInscricaoPage';
import EditLeagueTournament from './pages/liga/EditLeagueTournament';
import LeagueMembersPage from './pages/liga/LeagueMembersPage';
import FinanceiroLigaHub from './pages/liga/financeiro/FinanceiroLigaHub';
import PedidosReembolsoPage from './pages/atleta/reembolso/PedidosReembolsoPage';
import SearchPage from './pages/SearchPage';

export interface AppRoute {
  path: string;
  component: React.ComponentType;
  isPublic?: boolean;
  adminOnly?: boolean;
}

export const routes: AppRoute[] = [
  { path: '/', component: InstitucionalHome, isPublic: true },
  { path: '/torneios', component: InstitucionalTorneios, isPublic: true },
  { path: '/gestao', component: InstitucionalGestao, isPublic: true },
  { path: '/locacao', component: InstitucionalLocacao, isPublic: true },
  { path: '/parceiros', component: InstitucionalParceiros, isPublic: true },
  { path: '/clube', component: InstitucionalClube, isPublic: true },
  { path: '/landing', component: Landingpage, isPublic: true },
  { path: '/termos-de-uso', component: TermosDeUso, isPublic: true },
  { path: '/system-unavailable', component: SystemUnavailablePage, isPublic: true },
  { path: '/home', component: Home },
  { path: '/defaultbadge', component: Badge },
  { path: '/defaultstorie', component: Storie },
  { path: '/defaultgroup', component: Group },
  { path: '/socialaccount', component: Socialaccount },
  { path: '/password', component: Password },
  { path: '/accountinformation', component: AccountInfo },
  { path: '/defaultsettings', component: Settings },
  { path: '/login', component: Login, isPublic: true },
  { path: '/register', component: Register, isPublic: true },
  { path: '/forgot-request', component: ForgotRequest, isPublic: true },
  { path: '/forgot', component: Forgot, isPublic: true },
  { path: '/notfound', component: Notfound, isPublic: true },
  { path: '/comingsoon', component: Comingsoon, isPublic: true },
  { path: '/defaultnotification', component: Notification },
  { path: '/defaultemailbox', component: Email },
  { path: '/defaultmessage', component: Message },
  { path: '/defaultlive', component: Live, isPublic: true },
  { path: '/cart', component: Cart },
  { path: '/checkout', component: Checkout },
  { path: '/shop1', component: Shopone },
  { path: '/shop2', component: Shoptwo },
  { path: '/payment', component: Payment },
  { path: '/contactinformation', component: Contactinfo },
  { path: '/defaultvideo', component: Video },
  { path: '/grouppage', component: GroupPage },
  { path: '/userpage/:id/:postId?', component: Userpage },
  { path: 'athlete/matches/:id', component: AthleteMatchesPage },
  { path: '/singlematch/:id', component: SingleMatchPage },
  { path: '/authorpage', component: Authorpage },
  { path: '/defaultevent', component: Eventpage, isPublic: true },
  { path: '/leagues', component: LeaguesPage, isPublic: true },
  { path: '/league/:id', component: LeagueProfilePage, isPublic: true },
  { path: '/post/:postId', component: PostPage, isPublic: true },
  { path: '/defaultjob', component: Jobpage },
  { path: '/defaulthotel', component: Hotelpage },
  { path: '/defaulthoteldetails', component: Hotelsingle },
  { path: '/helpbox', component: Helpbox },
  { path: '/defaultemailopen', component: Eamilopen },
  { path: '/singleproduct', component: Singleproduct },
  { path: '/defaultanalytics', component: Analytic },
  { path: '/about', component: About, isPublic: true },
  { path: '/demo', component: Demo, isPublic: true },
  { path: '/tournamentsingle/:id', component: Tournamentsingle, isPublic: true },
  { path: '/tournament/:torneioId/category/:categoriaId', component: TournamentCategoryPage, isPublic: true },
  { path: '/tournamentinscriptioncheckout', component: TournamentInscriptionCheckout },
  { path: '/athlete/newinscriptionpayment', component: NewInscriptionPayment },
  { path: '/athlete/payment/:id', component: ViewInscriptionPayment },
  { path: '/athlete/tournamentinscriptions/:id', component: TournamentInscriptions },
  { path: '/athlete/payments', component: Payments },
  { path: '/athlete/financeiro', component: FinanceiroHub },
  { path: '/athlete/inscricao/:inscricaoId', component: InscricaoDetailPage },
  { path: '/admin/cupons', component: CuponsPage },
  { path: '/admin/usuarios', component: AdminUsuarios },
  { path: '/admin/payments/:id', component: AdminPayments },
  { path: '/admin/payments', component: AdminPayments },
  { path: '/admin/tournaments', component: Tournaments },
  { path: '/admin/ligas', component: Ligas },
  { path: '/admin/ligas/:id/edit', component: AdminEditLeague },
  { path: '/admin/tournamentfeed/:id', component: TournamentFeed },
  { path: '/admin/edittournament/:id', component: EditTournament },
  { path: '/admin/edittournament/:id/sponsors', component: AdminTournamentSponserPage },
  { path: '/admin/organizers', component: AdminTournamentOrganizerPage },
  { path: '/admin/discounts', component: AdminTournamentDiscountPage },
  { path: '/admin/editcategorytournament', component: EditCategoryTournament },
  { path: '/admin/editcategorytournament/:id', component: EditCategoryTournament },
  { path: '/admin/matchescategorytournament/:id', component: TournamentCategoryMatches },
  { path: '/admin/atletas/:id', component: EditAthlete },
  { path: '/admin/atletas', component: AdminAthletesPage },
  { path: '/admin/athlete/payments/:id', component: AthletePaymentsPage },
  { path: '/admin/paymentmethods', component: PaymentMethods },
  { path: '/admin/paymentmethods/', component: PaymentMethods },
  { path: '/admin/emailsnotificacoes', component: EmailsNotificacoes, adminOnly: true },
  { path: '/admin/financeiro', component: FinanceiroAdminPage, adminOnly: true },
  { path: '/liga/dashboard', component: LeagueDashboard },
  { path: '/liga/members', component: LeagueMembersPage },
  { path: '/liga/financeiro', component: FinanceiroLigaHub },
  // Redirect puro (Task 6, AC-A6): o gate NÃO é replicado aqui — quem não tem permissão é
  // barrado no destino, com a mesma mensagem byte-idêntica. `component` é uma arrow function
  // inline (não um identificador importado) de propósito: src/__tests__/rotas-shell.test.ts só
  // resolve rotas cujo `component` seja um import nomeado, então uma rota-redirect sem UI/shell
  // próprio fica fora do escopo daquele guardrail sem precisar de `// @sem-shell:`.
  { path: '/liga/payments', component: () => <Navigate to="/liga/financeiro" replace /> },
  { path: '/liga/edit', component: EditLeague },
  { path: '/liga/tournaments', component: LeagueTournaments },
  { path: '/liga/categorias', component: LeagueCategoriaLigaCatalog },
  { path: '/liga/categorias/nova', component: LeagueCategoriaLigaForm },
  { path: '/liga/categorias/:id/editar', component: LeagueCategoriaLigaForm },
  { path: '/liga/tournament/new', component: EditLeagueTournament },
  { path: '/liga/tournament/:id/edit', component: EditLeagueTournament },
  { path: '/liga/tournament/:id', component: LeagueTournamentManagement },
  { path: '/liga/tournament/:torneioId/category/:categoriaId', component: LeagueEditCategoryTournament },
  { path: '/liga/tournament/:torneioId/category/:categoriaId/manage', component: LeagueCategoryManagement },
  { path: '/liga/tournament/:torneioId/category/:categoriaId/imprimir', component: CategoryPrintPage },
  { path: '/liga/tournament/:torneioId/inscricao/nova', component: EditInscricaoPage },
  { path: '/liga/tournament/:torneioId/inscricao/:inscricaoId/editar', component: EditInscricaoPage },
  { path: '/liga/tournament/:torneioId/category/:categoriaId/inscricao/nova', component: EditInscricaoPage },
  { path: '/athlete/payments/:pagamentoId/refunds', component: PedidosReembolsoPage },
  { path: '/dev/breadcrumb-demo', component: BreadcrumbDemoPage, isPublic: true },
  // Quadras - Locatario
  { path: '/quadras/busca', component: QuadrasDisponiveis },
  { path: '/quadras/meus-agendamentos', component: MeusAgendamentos },
  { path: '/quadras/pagamento/:id', component: PagamentoAgendamento },
  { path: '/quadras/pagamento-pedido/:id', component: PagamentoPedido },
  { path: '/quadras/pedido/:id', component: PedidoDetalhe },
  { path: '/quadras/local/:id', component: LocalDetalhe },
  { path: '/quadras/:id', component: QuadraDetalhe },
  { path: '/quadras', component: CidadesQuadras },
  // Quadras - Admin
  { path: '/admin/quadras/nova', component: AdminQuadraForm },
  { path: '/admin/quadras/:id/editar', component: AdminQuadraForm },
  { path: '/admin/quadras/:id/configurar', component: AdminConfigurarQuadra },
  { path: '/admin/quadras/:id/agenda', component: AdminAgenda },
  { path: '/admin/quadras/:id/relatorio', component: AdminRelatorio },
  { path: '/admin/quadras/agenda-local/:localId', component: AdminAgendaLocal },
  { path: '/admin/quadras/taxa-conveniencia', component: AdminTaxaConveniencia, adminOnly: true },
  { path: '/admin/quadras', component: AdminQuadrasDashboard },
  { path: '/search', component: SearchPage },
];



